import {BehaviorSubject} from "rxjs";

export class APIHelper {
  public static APIUrl: string = 'https://exclusiven.era-erp.ro/VeracompDemoBackend/';
  public static _tokenBS: any = new BehaviorSubject<any>('');
  public static isAuth: boolean = false;
  public static _isAuthBS: any = new BehaviorSubject<any>('');
}
